import { useLottie } from "lottie-react";
import groovyWalkAnimation from "../../Assets/Loader/Loading.json";
import "./circularLoader.css"
import reactDom from "react-dom";

function CircularLoader() {
    const options = {
        animationData: groovyWalkAnimation,
        loop: true
    };
    const { View } = useLottie(options);
    return reactDom.createPortal(
        <div className="circular-loader">
            {View}
        </div>
        ,
        document.getElementById("root")
    )

}

export default CircularLoader;